'use strict';

module.exports = {
    DISCOVERED: 'hotFolder.files.discovered',
    CREATED: 'hotFolder.files.created',
    MODIFIED: 'hotFolder.files.modified',
    DELETED: 'hotFolder.files.deleted',
    FILE_EVENTS: 'hotFolder.files.events',
    SIGNATURE_STATUS: 'hotFolder.status.signature',
    HEALTH_CHECK_STATUS: 'hotFolder.status.healthCheck',
    INITIALIZATION_RESULT: 'hotFolder.cloudInitialization.result',
    INITIALIZATION_REQUEST: 'hotFolder.cloudInitialization.request',
    WALK_DONE: 'hotFolder.walk.done',
    CLOUD_STORAGE_STATUS: 'hotFolder.cloudStorage.status'
};